var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4122 10.7277C12.3985 11.8073 13.3744 12.4097 14.1094 12.7679C14.8647 13.1355 15.1184 13.3712 15.1155 13.6998C15.1097 14.2028 14.513 14.4248 13.9545 14.4334C12.9801 14.4485 12.4136 14.1704 11.9632 13.9599L11.6123 15.6023C12.0641 15.8106 12.9008 15.9923 13.7686 16.0002C15.8052 16.0002 17.1377 14.9948 17.1449 13.436C17.1529 11.4578 14.4085 11.3482 14.4272 10.4639C14.4337 10.1959 14.6896 9.90972 15.2503 9.83694C15.5277 9.80022 16.2938 9.77208 17.1622 10.172L17.5031 8.583C17.0361 8.4129 16.4357 8.25 15.6884 8.25C13.7714 8.25 12.4231 9.26904 12.4122 10.7277ZM20.7786 8.38692C20.4067 8.38692 20.0932 8.60388 19.9534 8.93682L17.044 15.8834H19.0792L19.4842 14.7642H21.9713L22.2062 15.8834H24L22.4347 8.38692H20.7786ZM21.0632 10.412L21.6506 13.227H20.042L21.0632 10.412ZM9.94464 8.38692L8.34042 15.8834H10.2797L11.8832 8.38692H9.94464ZM7.07562 8.38692L5.05698 13.4893L4.24044 9.15084C4.14462 8.66658 3.76626 8.38692 3.34608 8.38692H0.0461398L0 8.6046C0.67746 8.7516 1.44714 8.98872 1.9134 9.2424C2.19876 9.39732 2.28024 9.5328 2.3739 9.90108L3.92046 15.8834H5.97012L9.11226 8.38692H7.07562Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d5b04dacd74bb491a6b0a2c77305b97b.svg";
export { ForwardRef as ReactComponent };